/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React, { Component } from 'react';
import PropTypes from "prop-types";
import classNames from 'classnames';
import { EuiIcon } from '../../icon';
import { EuiPopover } from '../../popover';
import { EuiI18n } from '../../i18n';
import { EuiHeaderSectionItemButton, EuiHeaderSectionItem } from '../header_section';
export class EuiHeaderLinks extends Component {
  state = {
    isOpen: false
  };
  onMenuButtonClick = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });
  };
  closeMenu = () => {
    this.setState({
      isOpen: false
    });
  };

  componentDidMount() {
    window.addEventListener('resize', this.closeMenu);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.closeMenu);
  }

  render() {
    const {
      children,
      className,
      ...rest
    } = this.props;
    const classes = classNames('euiHeaderLinks', className);
    const button = <EuiHeaderSectionItem border="left">
        <EuiI18n token="euiHeaderLinks.openNavigationMenu" default="Open navigation menu">
          {openNavigationMenu => <EuiHeaderSectionItemButton aria-label={openNavigationMenu} onClick={this.onMenuButtonClick}>
              <EuiIcon type="apps" size="m" />
            </EuiHeaderSectionItemButton>}
        </EuiI18n>
      </EuiHeaderSectionItem>;
    return <EuiI18n token="euiHeaderLinks.appNavigation" default="App navigation">
        {appNavigation => <nav className={classes} aria-label={appNavigation} {...rest}>
            <div className="euiHeaderLinks__list" role="navigation">
              {children}
            </div>

            <EuiPopover className="euiHeaderLinks__mobile" ownFocus button={button} isOpen={this.state.isOpen} anchorPosition="downRight" closePopover={this.closeMenu} panelClassName="euiHeaderLinks__mobileList" panelPaddingSize="none">
              {children}
            </EuiPopover>
          </nav>}
      </EuiI18n>;
  }

}
EuiHeaderLinks.propTypes = {
  className: PropTypes.string,
  "aria-label": PropTypes.string,
  "data-test-subj": PropTypes.string
};

try {
  // @ts-ignore
  EuiHeaderLinks.displayName = "EuiHeaderLinks"; // @ts-ignore

  EuiHeaderLinks.__docgenInfo = {
    "description": "",
    "displayName": "EuiHeaderLinks",
    "props": {
      "className": {
        "defaultValue": null,
        "description": "",
        "name": "className",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "aria-label": {
        "defaultValue": null,
        "description": "",
        "name": "aria-label",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      },
      "data-test-subj": {
        "defaultValue": null,
        "description": "",
        "name": "data-test-subj",
        "required": false,
        "type": {
          "name": "string | undefined"
        }
      }
    }
  }; // @ts-ignore

  if (typeof STORYBOOK_REACT_CLASSES !== "undefined") // @ts-ignore
    STORYBOOK_REACT_CLASSES["src/components/header/header_links/header_links.tsx#EuiHeaderLinks"] = {
      docgenInfo: EuiHeaderLinks.__docgenInfo,
      name: "EuiHeaderLinks",
      path: "src/components/header/header_links/header_links.tsx#EuiHeaderLinks"
    };
} catch (__react_docgen_typescript_loader_error) {}